import api from './request'
import uuid from "~/utils/uuid";

// 定义所有可能的extraItem项目配置
const EXTRA_ITEM_CONFIG = [
    { key: 'BOX_SEND', value: '1' },           // 盒子发货
    { key: 'CUSTOMER_BAG', value: '2' }        // 客户打包袋
    // 后续可以继续添加其他项目，例如：
    // { key: 'SPECIAL_PACKAGE', value: '3' },   // 特殊包装
    // { key: 'FRAGILE_ITEM', value: '4' }       // 易碎品
]

/**
 * 获取当前启用的所有extraItem项目，返回逗号分隔的字符串
 * @returns {string|undefined} 例如: "1,2" 或 "1" 或 undefined
 */
function getExtraItem() {
    const enabledItems = []
    
    for (const config of EXTRA_ITEM_CONFIG) {
        try {
            const itemEnabled = JSON.parse(localStorage.getItem(config.key))
            if (itemEnabled) {
                enabledItems.push(config.value)
            }
        } catch (e) {
            // 忽略localStorage读取错误
        }
    }
    
    return enabledItems.length > 0 ? enabledItems.join(',') : undefined
}

/**
 * 保持向后兼容的getBoxSend函数
 */
function getBoxSend() {
    return getExtraItem()
}

function getDeviceMonitorId() {
    const deviceMonitorKey = 'deviceMonitorId'
    try {
        return JSON.parse(localStorage.getItem(deviceMonitorKey))
    } catch (e) {
        return null
    }
}

const scanQrText = (qrText, userId, logisticsId, num, matchChannel) => {
    let extraItem = getBoxSend()

    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }

    // 标记为同一个请求
    const requestId = uuid.getUUID(8, 16)
    return api.getPromise('warehouse/scanQrText', {qrText, userId, logisticsId, num, extraItem, matchChannel, requestId, deviceMonitorId})
}

const findMultiplePickingTasks = (teamId, warehouseCode) => {
    return api.getPromise('warehouse/findMultiplePickingTasks', {teamId, warehouseCode})
}

const findMultipleOrder = (teamId, taskId, qrText, page, size, warehouseCode, matchFlag, stockOutId, fullData = false) => {
    if (qrText instanceof Array) {
        return api.postPromise('warehouse/findMultipleOrder', {teamId, taskId, page, size, warehouseCode, matchFlag, stockOutId}, qrText, null, fullData)
    } else {
        return api.getPromise('warehouse/findMultipleOrder', {teamId, taskId, qrText, page, size, warehouseCode, matchFlag, stockOutId}, null, fullData)
    }
}

const multipleOrderSend = (id, logisticsId, userId, warehouseCode, stockOutId) => {

    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }

    let extraItem = getBoxSend()
    const requestId = uuid.getUUID(8, 16)
    if (id instanceof Array) {
        return api.postPromise('warehouse/multipleOrderSend', {logisticsId, userId, warehouseCode, extraItem, requestId, deviceMonitorId, stockOutId}, id)
    }
    return api.getPromise('warehouse/multipleOrderSend', {id, logisticsId, userId, warehouseCode, extraItem, requestId, deviceMonitorId, stockOutId})
}

const reprintOrder = waybillId => {

    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }

    return api.getPromise('warehouse/reprintOrder', {waybillId, deviceMonitorId})
}

const findSkuSendRecord = (qrText, duration) => {
    return api.getPromise('warehouse/findSkuSendRecord', {qrText, duration})
}

const creatMultipleTaskGroup = (modal) => {
    return api.postPromise('warehouse/creatMultipleTaskGroup', {}, modal)
}

const findAllRemnantReadyOrderGroup = (teamId, type, qrText, warehouseCode) => {
    return api.getPromise('warehouse/findAllRemnantReadyOrderGroup', {teamId, type, qrText, warehouseCode})
}

const errOrderSign = id => {
    return api.getPromise('warehouse/errOrderSign', {preId: id})
}

const assureFinished = teamId => {
    return api.getPromise('delivery/assureFinished', {teamId})
}

const reprintGroupLabel = (groupId, printerCode) => {
    return api.getPromise('warehouse/reprintGroupLabel', {groupId, printerCode})
}

const getSkuFromQrText = (qrText) => {
    return api.getPromise('warehouse/getSkuFromQrText', {qrText})
}

const getSkuInfoForScanQrText = (qrText) => {
    return api.getPromise('warehouse/getSkuInfoForScanQrText', {qrText})
}

const scanMultipleQrText = (qrText, sowingCellId, teamId) => {
    return api.getPromise('warehouse/scanMultipleQrText', {qrText, sowingCellId, teamId})
}

const multipleOrderSendBySowing = (sowingCellId, logisticsId, userId, qrCodes, teamId) => {
    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }
    let extraItem = getBoxSend()
    const requestId = uuid.getUUID(8, 16)
    return api.postPromise('warehouse/multipleOrderSendBySowing',
        {sowingCellId, logisticsId, userId, teamId, extraItem, requestId, deviceMonitorId}, qrCodes)
}

const batchMultipleOrderSendBySowing = ({parentCellId, logisticsId, userId, cellIds}) => {
    let extraItem = getBoxSend()
    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }
    const requestId = uuid.getUUID(8, 16)
    if (cellIds && cellIds.length) {
        return api.postPromise('warehouse/batchMultipleOrderSendBySowing', {
            parentCellId,
            logisticsId,
            userId,
            extraItem,
            requestId,
            deviceMonitorId
        }, cellIds)
    } else {
        return api.getPromise('warehouse/batchMultipleOrderSendBySowing', {
            parentCellId,
            logisticsId,
            userId,
            extraItem,
            requestId,
            deviceMonitorId
        })
    }
}

const findOrdersInSowingCell = (sowingCellId) => {
    return api.getPromise('warehouse/findOrdersInSowingCell', {sowingCellId})
}

const createMultipleTaskGroupByOrderNum = (teamId, warehouseCode) => {
    return api.getPromise('warehouse/createMultipleTaskGroupByOrderNum', {teamId, warehouseCode})
}

const preMatchedOrderList = (query, order) => {
    return api.postPromise('warehouse/preMatchedOrderList', query, order, null, true)
}

const scanAndSendRandomly = ({qrText, logisticsId, teamId}) => {
    return api.getPromise('warehouse/scanAndSendRandomly', {
        qrText,
        logisticsId,
        teamId
    })
}

const multipleOrderSendV2 = (id, logisticsId, userId, warehouseCode, codeQrTextList, matchFlag, stockOutId) => {
    const deviceMonitorId = getDeviceMonitorId()
    if (!deviceMonitorId) {
        return Promise.reject({
            message: '请选择发货设备'
        })
    }
    let extraItem = getBoxSend()
    const requestId = uuid.getUUID(8, 16)
    return api.postPromise('warehouse/multipleOrderSendV2', {
        id,
        logisticsId,
        userId,
        warehouseCode,
        extraItem,
        requestId,
        deviceMonitorId,
        matchFlag,
        stockOutId
    }, codeQrTextList)
}

export default {
    scanQrText,
    findMultiplePickingTasks,
    findMultipleOrder,
    multipleOrderSend,
    reprintOrder,
    findSkuSendRecord,
    creatMultipleTaskGroup,
    findAllRemnantReadyOrderGroup,
    errOrderSign,
    assureFinished,
    reprintGroupLabel,
    getSkuFromQrText,
    getSkuInfoForScanQrText,
    scanMultipleQrText,
    multipleOrderSendBySowing,
    findOrdersInSowingCell,
    createMultipleTaskGroupByOrderNum,
    batchMultipleOrderSendBySowing,
    preMatchedOrderList,
    scanAndSendRandomly,
    getDeviceMonitorId,
    multipleOrderSendV2,
    getExtraItem
}



// WEBPACK FOOTER //
// ./src/request/warehouseApi.js